export const education = [
    {
        institute : "IIT - BHU",
        title : "BTech Metallurgical Engineering",
        startYear : "2020",
        endYEear : "2024",
        grade : "9.32"
    }, 
    {
        institute : "Holy Child School",
        title : "Intermediate Science ( PCM )",
        startYear : "2017",
        endYEear : "2019",
        grade : "96.4 %"
    }, 
    {
        institute : "Jaycees Public School",
        title : "Class X",
        startYear : "2016",
        endYEear : "2017",
        grade : "10 CGPA"
    }, 
]

export const experience = [
    {
        institute : "Amazon (Prime Video Payments)",
        title : "SDE - 1",
        startYear : "Sept 2024",
        endYEear : "Present"
    }, 
    {
        institute : "Physics Wallah",
        title : "SDE - 1",
        startYear : "May 2024",
        endYEear : "Aug 2024"
    }, 
    {
        institute : "Amazon",
        title : "SDE Intern",
        startYear : "May 2023",
        endYEear : "July 2023"
    }, 
    // {
    //     institute : "SNTC IIT BHU",
    //     title : "Tech Executive",
    //     startYear : "Jan 2022",
    //     endYEear : "Jul 2022"
    // }, 
]